// extracted by mini-css-extract-plugin
module.exports = {"stTools":"DebugPopup_stTools__2dkE2","overlay":"DebugPopup_overlay__2-EXr","popup":"DebugPopup_popup__1Fmr7","triggerButton":"DebugPopup_triggerButton__3ajBM"};